// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__1KAXZ","title":"styles_title___tUR2","spacer":"styles_spacer__2cflH","toggle":"styles_toggle__ynnhJ","body":"styles_body__UZrti"};